import { render, staticRenderFns } from "./inputs.vue?vue&type=template&id=58959b32"
import script from "./inputs.vue?vue&type=script&lang=js"
export * from "./inputs.vue?vue&type=script&lang=js"
import style0 from "./inputs.vue?vue&type=style&index=0&id=58959b32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports